import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['startDate', 'endDate', 'preset']

  static values = {
    startDate: String,
    endDate: String
  }

  connect() {
    // Set default to last 30 days if not set
    if (!this.startDateValue) {
      this.setPreset('30d')
    } else {
      this.syncInputs()
    }
  }

  setPreset(period) {
    const end = new Date()
    const start = new Date()

    switch (period) {
      case '7d':
        start.setDate(end.getDate() - 7)
        break
      case '30d':
        start.setDate(end.getDate() - 30)
        break
      case '90d':
        start.setDate(end.getDate() - 90)
        break
      case 'ytd':
        start.setMonth(0, 1) // January 1st
        break
    }

    this.startDateValue = this.formatDate(start)
    this.endDateValue = this.formatDate(end)
    this.syncInputs()
    this.updateActivePreset(period)
    this.dispatchUpdate()
  }

  preset7d() {
    this.setPreset('7d')
  }

  preset30d() {
    this.setPreset('30d')
  }

  preset90d() {
    this.setPreset('90d')
  }

  presetYtd() {
    this.setPreset('ytd')
  }

  customRange() {
    if (this.hasStartDateTarget && this.hasEndDateTarget) {
      this.startDateValue = this.startDateTarget.value
      this.endDateValue = this.endDateTarget.value
      this.clearActivePresets()
      this.dispatchUpdate()
    }
  }

  syncInputs() {
    if (this.hasStartDateTarget) {
      this.startDateTarget.value = this.startDateValue
    }
    if (this.hasEndDateTarget) {
      this.endDateTarget.value = this.endDateValue
    }
  }

  updateActivePreset(period) {
    this.presetTargets.forEach((btn) => {
      const isActive = btn.dataset.period === period
      btn.classList.toggle('bg-slate-900', isActive)
      btn.classList.toggle('text-white', isActive)
      btn.classList.toggle('bg-white', !isActive)
      btn.classList.toggle('text-slate-700', !isActive)
    })
  }

  clearActivePresets() {
    this.presetTargets.forEach((btn) => {
      btn.classList.remove('bg-slate-900', 'text-white')
      btn.classList.add('bg-white', 'text-slate-700')
    })
  }

  dispatchUpdate() {
    this.dispatch('rangeChanged', {
      detail: {
        startDate: this.startDateValue,
        endDate: this.endDateValue
      }
    })
  }

  formatDate(date) {
    return date.toISOString().split('T')[0]
  }
}
